import React from "react";

import { LeftSideBar } from "./LeftSideBar";
import { ToolBar } from "./Toolbar";

// Sidebar + navbar chrome for the pages that aren't the chart grid.
// Layout.js and the RNG page build the same chrome into their own grids
// because their content has to share columns with the sidebar.
export default function PageShell(props) {
  const shellStyle = {
    display: "grid",
    gridTemplateColumns: "[side-bar] 220px [content] minmax(0, 1fr)",
    gridTemplateRows: "[navbar] 76px [content-row] minmax(0, 1fr)",
    minHeight: "100vh"
  };
  const sideBarStyle = {
    gridColumn: "side-bar",
    gridRow: "navbar / -1",
    display: "grid"
  };
  const navBarStyle = {
    gridColumn: "content",
    gridRow: "navbar",
    display: "grid"
  };
  const contentStyle = {
    gridColumn: "content",
    gridRow: "content-row",
    minWidth: "0%"
  };
  return (
    <div style={shellStyle}>
      <div style={sideBarStyle}>
        <LeftSideBar />
      </div>
      <div style={navBarStyle}>
        <ToolBar />
      </div>
      <div style={contentStyle}>{props.children}</div>
    </div>
  );
}
